"use client";

import React, { useState } from "react";
import { Button } from "primereact/button";

import { CreditNoteValidationForm } from "./CreditNoteValidationForm";

interface CreditNoteValidationButtonProps {
  disabled?: boolean;
}

export function CreditNoteValidationButton({ disabled }: CreditNoteValidationButtonProps) {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <>
      <Button
        className="w-12rem md:my-4 h-4rem"
        label="Validate Credit Notes"
        icon="pi pi-check-circle"
        onClick={() => setModalVisible(true)}
        disabled={disabled}
      />

      <CreditNoteValidationForm
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
      />
    </>
  );
}
